import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import showToast from './Toast/ToastNotification'
import { performLogout } from './logoutHelper'

const INACTIVITY_TIME = 60 * 60 * 1000     //1 hr 
const WARNING_BEFORE = 1 * 60 * 1000  //warning before 1 min

const Inactivity = () => {

    const navigate = useNavigate()
    const timerRef = useRef(null)
    const warningTimerRef = useRef(null)


    const warningShownRef = useRef(false)

    const handleLogout = async (fromStorage = false) => {

        if (!fromStorage) {
            localStorage.setItem("logout", Date.now())
        }
        await performLogout(navigate);
        if (!fromStorage) showToast("error", "Logged out due to Inactivity")
    }

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current)
        if (warningTimerRef.current) clearTimeout(warningTimerRef.current)
        warningShownRef.current = false

        // Broadcast activity to other tabs
        localStorage.setItem("lastActivity", Date.now())

        // Set logout timer
        timerRef.current = setTimeout(() => handleLogout(false), INACTIVITY_TIME)

        // Set warning timer
        warningTimerRef.current = setTimeout(() => {
            if (!warningShownRef.current) {
                showToast("warn", "You will be logged out in 1 minute due to inactivity.")
                warningShownRef.current = true
            }
        }, INACTIVITY_TIME - WARNING_BEFORE)
    }

    useEffect(() => {
        const events = ["mousemove", "scroll", "keydown", "mousedown", "touchstart"]

        events.forEach(event => window.addEventListener(event, resetTimer))
        resetTimer();

        // Cross-tab logout detection
        const storageListener = (e) => {
            if (e.key === "logout") {
                handleLogout(true) // true indicates it came from another tab
            }
        }
        window.addEventListener("storage", storageListener)

        const activityListener = (e) => {
            if (e.key === "lastActivity") {
                resetTimer() // Reset timer if other tab is active
            }
        }
        window.addEventListener("storage", activityListener)

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current)
            if (warningTimerRef.current) clearTimeout(warningTimerRef.current)
            events.forEach(event => window.removeEventListener(event, resetTimer))
            window.removeEventListener("storage", storageListener)
        }
    }, [])

    return null;
}

export default Inactivity;